export default class Middleware {
	constructor (name, handler) {
		return {
			name,
			handler (context) {
				// if (process.env.NODE_ENV === 'development') {
				// 	console.error('[Middleware] Applying:', name)
				// }
				return handler(context)
			}
		}
	}
}
